<template>
  <div class="search-bar">
    <img v-if="!query" src="@/assets/images/search-icon.svg">
    <img v-else @click="changeQuery()" src="@/assets/images/cancel-icon.svg" class="empty-search">
    <input type="text" placeholder="Поиск по разделу" :value="query" @input="debounceInput">
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapGetters, mapActions } from 'vuex';

export default {

  computed: {
    ...mapGetters({
      query: 'util/searchQuery',
    }),
  },

  methods: {
    ...mapActions({
      changeQuery: 'util/changeQuery',
    }),

    debounceInput: debounce(function(event) {
      this.changeQuery(event.target.value);
    }, 200),
  },
};
</script>


<style lang="scss" scoped>
.search-bar {
  width: 60%;
  height: 40px;
  margin-right: auto;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0 20px;

  input {
    margin-left: 20px;
    width: 100%;
    border: 0;
    font-size: 1.1em;
    padding: 20px 10px;
    outline: none;
  }

  .empty-search {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
